module.exports = __webpack_public_path__ + "static/media/CTLI_14-235w.98c03570.png";